export default __webpack_public_path__ + "static/media/digital-ocean.744a6973.svg";